<script setup>
import {defineProps, defineEmits, computed ,ref} from "vue";
import HeaderDeAdiantamentos from "./HeaderDeAdiantamentos.vue";
import BodyDeAdiantamentos from "./BodyDeAdiantamentos.vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "parcela",
]);

const emits = defineEmits([
    "update:alteraAdiantamento",
]);

//==================================================================//
//====================== Altera Adiantamento =======================//
//==================================================================//

const alteraAdiantamento = (update)=>{

    emits('update:alteraAdiantamento',update);

};

</script>

<template>

    <div class="c-table-wrapper">

        <div class="c-table">

            <HeaderDeAdiantamentos
                :dado="dado"
                :parcela="parcela"
            ></HeaderDeAdiantamentos>

            <BodyDeAdiantamentos
                :dado="dado"
                :parcela="parcela"
                @update:alteraAdiantamento="alteraAdiantamento"
            ></BodyDeAdiantamentos>

        </div>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*=============================== Tabela ===========================*/
/*==================================================================*/

.c-table-wrapper{
    overflow: hidden !important;
    padding: 12px !important;
}

.c-table{
    display: grid;
    grid-template-columns: max-content max-content max-content max-content max-content max-content max-content max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(196, 74, 74, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

</style>